import React from 'react'
import styled from 'styled-components'
import { useControlValue } from '../../Contexts/ControlContext'
import { useInfoValue } from '../../Contexts/InfoContext'
import { InputRadio } from '../../Common/InputRadio'
import { ToggleSwitch } from '../../Common/ToggleSwitch'
import { Description } from '../../Common/Description'

export const Templates = () => {
	const { controlData, changeTemplate } = useControlValue()
	const { infoData, toggleReferral } = useInfoValue()
	const templateTypes = [
		{
			label: 'Horizontal',
			name: 'template1',
		},
		{
			label: 'Vertical',
			name: 'template2',
		},
	]

	return (
		<StyledForm>
			<div className="toggle">
				<span>A Tool Made By Design Buffs</span>
				<ToggleSwitch checked={infoData.showReferral} onChange={toggleReferral} />
			</div>
			<Description>Select your layout</Description>
			{templateTypes.map(templateType => (
				<InputRadio
					label={templateType.label}
					name={templateType.name}
					checked={controlData.template}
					onChange={changeTemplate}
					key={templateType.name}
				/>
			))}
		</StyledForm>
	)
}

const StyledForm = styled.form`
	animation: flipdown 0.2s ease both;
	.toggle {
		display: flex;
		justify-content: left;
	}
	span {
		margin-right: 0.8rem;
		padding: 0.9rem 0;
	}
`
